
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clanok/[...slug]",
      function () {
        return require("private-next-pages/clanok/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clanok/[...slug]"])
      });
    }
  